import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {TranslationProvider} from "./context/translationContext";
import Search from "./apps/Search";
import {getJsonDataFromDataAttribute} from "./utility/jsonDataExctractor";



const searchRoot : NodeListOf<Element> = document.querySelectorAll('[data-nezzo-search-search]');

if(searchRoot !== null) {
    for (let i = 0; i < searchRoot.length; i++) {
        const searchElement = searchRoot[i];
        const searchParent = searchElement.parentElement?.parentElement;

        if (searchParent) {
            const translationScriptTag = searchParent.querySelector('[data-nezzo-search-search-translations]');
            const translations = JSON.parse(translationScriptTag ? translationScriptTag.innerHTML : '[]');

            const searchResultLink = searchElement.getAttribute('data-nezzo-search-search-resulturl') ?? '';
            const searchQuicklinks =  getJsonDataFromDataAttribute(searchElement, 'nezzo-search-search-quicklinks');

            ReactDOM.render(
                <TranslationProvider value={translations}>
                    <Search
                        searchResultLink={searchResultLink}
                        searchQuicklinks={searchQuicklinks}
                    />
                </TranslationProvider>,
                searchElement
            );
        }
    }
}
